import Grid from '@mui/material/Grid'
import { ReactNode, useState } from 'react'
import Container from '@mui/material/Container'

import SideNav from './SideNav'
import Header from '../layouts/Header'

function UserLayout({ children }: { children?: ReactNode }): JSX.Element {
  const [open, setOpen] = useState(false)
  const handleDrawerOpen = () => {
    setOpen(true)
  }
  const handleDrawerClose = () => {
    setOpen(false)
  }

  return (
    <>
      <SideNav open={open} handleDrawerOpen={handleDrawerOpen} handleDrawerClose={handleDrawerClose} />
      <Header handleDrawerOpen={handleDrawerOpen} />
      <Container disableGutters component="main" maxWidth={false} sx={{ pl: { lg: '71px' }, pb: '40px' }}>
        <Grid
          container
          direction="column"
          justifyContent="flex-start"
          alignItems="center"
          className="h-full max-h-full"
          sx={{ mt: '71px' }}
        >
          {children}
        </Grid>
      </Container>
    </>
  )
}

export default UserLayout
